import { useRef } from 'react';
import { deepEqual } from './deep-equal';

/**
 * `useDeepMemo` will only recompute the memoized value when one of the `deps` has changed (using deep comparison).
 *
 * Usage note: Only use deep memo if you need to deeply compare your dependencies.
 * This is usually objects which are recreated with each render (not memod). Otherwise use `useMemo` from React
 *
 * @param memoFn Function that returned a calculated value base on the current dependencies
 * @param nextDeps If present, recalculation will only activate if the values in the list change (deep comparison)
 *
 * @see https://pushpay.atlassian.net/wiki/spaces/PPPCI/pages/694423208/Front+End+Coding+Guidelines#FrontEndCodingGuidelines-WhentouseuseDeepMemoanduseDeepEffecthooks
 */
export default function useDeepMemo(memoFn, nextDeps) {
  var _ref;
  const ref = useRef();
  const isEqual = deepEqual(nextDeps !== null && nextDeps !== void 0 ? nextDeps : null, (_ref = ref.current && ref.current.deps) !== null && _ref !== void 0 ? _ref : null);
  if (!(ref.current && isEqual)) {
    ref.current = {
      deps: nextDeps,
      value: memoFn()
    };
  }
  return ref.current.value;
}